import { render, staticRenderFns } from "./selectNewCategoryDetail.vue?vue&type=template&id=9090fc24&scoped=true"
import script from "./selectNewCategoryDetail.vue?vue&type=script&lang=js"
export * from "./selectNewCategoryDetail.vue?vue&type=script&lang=js"
import style0 from "../../statistics/css/hunting.css?vue&type=style&index=0&id=9090fc24&prod&scoped=true&lang=css&external"
import style1 from "./selectNewCategoryDetail.vue?vue&type=style&index=1&id=9090fc24&prod&scoped=true&lang=css"
import style2 from "./selectNewCategoryDetail.vue?vue&type=style&index=2&id=9090fc24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9090fc24",
  null
  
)

export default component.exports